import { Link } from 'react-router-dom';

import { PageState } from '@/shared/ui/PageState';

import { routePaths } from './routePaths';

export function NotFoundPage() {
  return (
    <PageState
      title="Seite nicht gefunden"
      description="Diese Adresse gehört nicht zum Turnierportal."
      action={
        <Link
          to={routePaths.home}
          className="bg-brand hover:bg-brand-hover text-brand-fg touch-target rounded-lg px-5 py-3 font-medium transition-colors"
        >
          Zur Startseite
        </Link>
      }
    />
  );
}
